import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 0c3 4.5 7.5 9 12 12-4.5 3-9 7.5-12 12-3-4.5-7.5-9-12-12C4.5 9 9 4.5 12 0m0 3.086A48.7 48.7 0 0 1 3.086 12 48.7 48.7 0 0 1 12 20.913 48.7 48.7 0 0 1 20.913 12 48.7 48.7 0 0 1 12 3.086"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarOutlinedSize24Glyph.displayName = 'HyperstarOutlinedSize24Glyph';
